import { Route, Routes } from 'react-router-dom';

import { useAppId } from '@verantos-dev/app-state-base';
import { withAuth } from '@verantos-dev/core-auth';
import { appIdToClaimCheckDefinitionMap } from '@verantos-dev/core-constants';
import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';
import { DataReliabilityPage } from '@verantos-dev/feature-data-reliability';

// TODO: cleanup with data_reliability ff
const APP_ID = EvidencePlatformSidebarAppID.dataReliability;

export const DataReliabilityUiRoutes = () => {
  useAppId(APP_ID);

  return (
    <Routes>
      <Route index element={<DataReliabilityPage />} />
    </Routes>
  );
};

export default withAuth(DataReliabilityUiRoutes, APP_ID, appIdToClaimCheckDefinitionMap);
